import React, { useEffect, useState } from "react";
import Button from "../../component/button/Button";
import InputText from "../../component/inputText/InputText";
import styles from "./SignUp.module.css";
import { useNavigate } from "react-router-dom";
import { creatorSignUpApi } from "../../api/HttpApis";
import { showToast } from "../../utils/Toastify/Toastify";
import { useTenant } from "../../context/TenantContext";

function SignUp() {
  const { logo } = useTenant();
  const [email, setEmail] = useState();
  const [loading, setLoading] = useState(false);
  const [isEmailPrefilled, setIsEmailPrefilled] = useState(false);
  const navigate = useNavigate();


  const handleSignUp = async () => {
    setLoading(true);
    try {
      const response = await creatorSignUpApi(email);
      const { message, data } = response?.data || {};

      showToast(message, "success");

      // Handle already registered case first
      if (message?.toLowerCase().includes("already registered")) {
        showToast(message, "success");
        navigate("/", { replace: true });
        return;
      }

      // Otherwise handle new Creator signup
      if (data) {
        localStorage.setItem("role", data?.role);
        localStorage.setItem("token", data?.token);
        localStorage.setItem("refreshToken", data?.refresh_token);
        localStorage.setItem("expireDate", data?.expire_date);
        localStorage.setItem("authEvent", "login");
        window.dispatchEvent(new Event("storage"));

        if (data?.role === "Creator") {
          navigate("/creator-onboarding", { state: data });
        } else {
          navigate("/", { replace: true });
        }
      }
    } catch (error) {
      showToast(
        error?.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(e.target.value);
  };
  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expireDate");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("role");
    const params = new URLSearchParams(window.location.hash.split("?")[1]);
    const emailParam = params.get("email");
    if (emailParam) {
      setEmail(emailParam);
      setIsEmailPrefilled(true);
    }
  }, []);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <p className={styles.paraTextHeading}>Already have an account?</p>
          <div
            className={styles.signInText}
            onClick={() => navigate("/")}
          >
            <u> Sign In </u>
          </div>
        </div>
        <img src={logo} alt="Logo" className={styles.logo} />
        <div className={styles.inputGroup}>
          <InputText
            type="text"
            autofocus={true}
            placeholder="Enter Your Email Address"
            className={`${styles.inputBox} ${isEmailPrefilled ? styles.prefilled : ""}`}
            value={email}
            onChange={(e) => handleChange(e)}
            readOnly={isEmailPrefilled}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSignUp();
            }}
          />
          <Button onClick={handleSignUp} loading={loading} variant="dark">
            Sign Up
          </Button>
        </div>
      </div>
    </>
  );
}

export default SignUp;
